module.exports = __webpack_public_path__ + "static/shapes@2x.67267fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/shapes@2x.png
// module id = 450
// module chunks = 35783957827783